import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import ReactGA from "react-ga";

ReactGA.pageview(window.location.pathname + window.location.search);

const ContactSection = () => {
  return (
    <div>
      <NavBar />
      <div className="bg-black text-white p-8">
        <div className="max-w-6xl mx-auto flex flex-wrap py-20">
          <div className="w-full md:w-1/3 mb-8 md:mb-0">
            <h2 className="text-xl font-semibold mb-10">Get in Touch</h2>
            <h1 className="text-6xl font-bold font-poppins">Contact</h1>
          </div>
          <div className="w-full md:w-2/3">
            <p className="mb-12">
              Lorem ipsum dolor sit amet consectetur. Rhoncus urna purus massa
              odio sit donec nisl. Imperdiet tempor phasellus hendrerit turpis
              augue turpis vulputate. Massa elementum velit dui enim id.
              Vestibulum scelerisque nunc sit sit quis facilisis morbi nunc
              gravida. Lorem ipsum dolor sit amet consectetur. Rhoncus urna
              purus massa odio sit donec nisl. Imperdiet tempor phasellus
              hendrerit turpis augue turpis vulputate. Massa elementum velit dui
              enim id. Vestibulum scelerisque nunc sit sit quis facilisis morbi
              nunc gravida.
            </p>
            <div className="flex flex-wrap -mx-4">
              <div className="w-full md:w-1/2 px-4 mb-4">
                <div className="flex items-start">
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="text-xl mr-2"
                  />
                  <div className="mb-4">
                    <span className="text-lg font-semibold font-poppins">
                      Address
                    </span>
                    <p className="font-light">Musanze, Rwanda</p>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 px-4 mb-4">
                <div className="flex items-start">
                  <FontAwesomeIcon icon={faPhone} className="text-xl mr-2" />
                  <div className="mb-4">
                    <span className="text-lg font-semibold font-poppins">
                      Phone
                    </span>
                    <p className="font-light">+250 798 685 382</p>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 px-4 mb-4 mt-4">
                <div className="flex items-start">
                  <FontAwesomeIcon icon={faEnvelope} className="text-xl mr-2" />
                  <div>
                    <span className="text-lg font-semibold font-poppins">
                      Email
                    </span>
                    <p className="font-light">
                      studioofafricanwildlifeart@gmail.com
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 px-4 mb-4 mt-4">
                <div className="flex items-start">
                  <FontAwesomeIcon icon={faThumbsUp} className="text-xl mr-2" />
                  <span className="text-lg font-semibold font-poppins">
                    Social Links
                  </span>
                </div>
                <div className="flex mt-2 ml-8">
                  <a href="#" className="text-xl mr-4">
                    <FontAwesomeIcon icon={faTwitter} />
                  </a>
                  <a href="#" className="text-xl mr-4">
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                  <a href="#" className="text-xl mr-4">
                    <FontAwesomeIcon icon={faFacebook} />
                  </a>
                  <a href="#" className="text-xl mr-4">
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactSection;
